<template>
    <el-dialog
        :title="$t('marketing.affiliate.commission.adjust')"
        :visible="visible"
        width="520px"
        append-to-body
        :close-on-click-modal="false"
        @update:visible="(v) => $emit('update:visible', v)"
        @open="onOpen"
    >
        <div data-testid="aff-adjust-dialog">
            <div class="form-group">
                <label class="form-control-label">Affiliate</label>
                <el-select
                    v-model="form.affiliate_member_id"
                    class="w-100"
                    filterable
                    remote
                    clearable
                    :remote-method="search"
                    :loading="searching"
                    :placeholder="$t('marketing.affiliate.member.search')"
                    data-testid="aff-adjust-affiliate"
                    @visible-change="(o) => o && !options.length && search('')"
                >
                    <el-option v-for="o in options" :key="o.member_id" :value="o.member_id" :label="o.code + ' · ' + o.name"></el-option>
                </el-select>
                <small v-if="errors.affiliate_member_id" class="text-danger">{{ $t("marketing.affiliate.err." + errors.affiliate_member_id) }}</small>
            </div>
            <div class="form-group">
                <label class="form-control-label">{{ $t("marketing.affiliate.commission.adjust_amount") }} (฿)</label>
                <el-input v-model="form.amount" placeholder="-25.00" inputmode="decimal" data-testid="aff-adjust-amount"></el-input>
                <small class="d-block text-muted">{{ $t("marketing.affiliate.commission.adjust_amount_hint") }}</small>
                <small v-if="errors.amount" class="text-danger">{{ $t("marketing.affiliate.err.amount") }}</small>
            </div>
            <div class="form-group">
                <label class="form-control-label">{{ $t("marketing.affiliate.commission.adjust_order_no") }}</label>
                <el-input v-model="form.order_no" maxlength="32"></el-input>
            </div>
            <div class="form-group mb-0">
                <label class="form-control-label">{{ $t("marketing.affiliate.commission.adjust_note") }}</label>
                <el-input v-model="form.note" type="textarea" :rows="3" maxlength="500" data-testid="aff-adjust-note"></el-input>
                <small v-if="errors.note" class="text-danger">{{ $t("marketing.affiliate.err." + errors.note) }}</small>
            </div>
        </div>
        <span slot="footer">
            <base-button type="secondary" @click="$emit('update:visible', false)">{{ $t("marketing.affiliate.cancel") }}</base-button>
            <base-button type="primary" :loading="saving" data-testid="aff-adjust-save" @click="save">{{ $t("marketing.affiliate.save") }}</base-button>
        </span>
    </el-dialog>
</template>

<script>
import { Dialog, Select, Option, Input } from "element-ui";
import { AffiliateService } from "@/resource";
import { adjustErrors, adjustPayload } from "@/utils/affiliate";
import affiliateMixin from "./affiliateMixin";

// ปรับยอด (Phase 3 spec 2026-10-13 §5.4): affiliate · ± amount (2 dp) ·
// order no (optional) · note (required). affiliate_finance write only.
export default {
    name: "AffiliateAdjustDialog",
    components: { [Dialog.name]: Dialog, [Select.name]: Select, [Option.name]: Option, [Input.name]: Input },
    mixins: [affiliateMixin],
    props: { visible: { type: Boolean, default: false } },
    data() {
        return { form: { affiliate_member_id: null, amount: "", order_no: "", note: "" }, errors: {}, options: [], searching: false, saving: false };
    },
    methods: {
        onOpen() {
            this.form = { affiliate_member_id: null, amount: "", order_no: "", note: "" };
            this.errors = {};
        },
        async search(q) {
            this.searching = true;
            try {
                const res = await AffiliateService.affiliates(q ? { q, limit: 20 } : { limit: 20 });
                this.options = (res.data && res.data.data) || [];
            } catch (e) {
                this.options = [];
            } finally {
                this.searching = false;
            }
        },
        async save() {
            this.errors = adjustErrors(this.form);
            if (Object.keys(this.errors).length) return;
            this.saving = true;
            try {
                await AffiliateService.adjust(adjustPayload(this.form));
                this.notifyOk();
                this.$emit("saved");
                this.$emit("update:visible", false);
            } catch (err) {
                this.showError(err);
            } finally {
                this.saving = false;
            }
        }
    }
};
</script>
